module.exports = __webpack_public_path__ + "img/Pic_Support-2_b.a159cd9e.jpg";